import {PammOfferType} from '../../../graphql/types'

/**
 * Name the PAMM platform auto-assigns to the offer it creates alongside a manager account.
 * It is an internal label, never something the Money Manager chose.
 */
export const AUTO_CREATED_OFFER_NAME = 'Default'

/**
 * The title to show on an offer card.
 *
 * Normally the offer's own name. The auto-created "Default" offer is the exception: it carries the
 * manager's network (every agent chain of length 1 hangs off it), so it is rendered as the tree's
 * root rather than hidden (PT-5875) — but showing it as "Default" would label the manager's own
 * node with an internal string. Fall back to the offer name when the manager has no name on record.
 *
 * @param offer - The offer whose card is being rendered.
 * @returns The card title.
 */
export const offerDisplayName = (offer: PammOfferType): string =>
  offer.name === AUTO_CREATED_OFFER_NAME ? offer.managerName || offer.name || '' : offer.name || ''
